// vs-comparison 动画：高亮第几对 stat（-1 表示无）。
import type { SceneData } from '../../api/types'
import type { VsData } from './types'

export function vsHighlight(d: SceneData, time: number): number {
  const data = d as unknown as VsData
  const statCount = data.left?.stats?.length ?? 0
  const statInterval = 2.5
  const idx = Math.floor(time / statInterval)
  return idx < statCount ? idx : -1
}
